import {ExtraServiceDto} from '@lib/infrastructure';
import {Building, Extra} from '../entities';
import omit from 'lodash/omit';
import flatMap from 'lodash/flatMap';
import {ExtraService, ExtraServicesByCategoryByBuildingIdType} from './types';
import {Dictionary} from '@reduxjs/toolkit';

export const compareExtrasWorkdayFirstAlphabetical = (e1: Extra, e2: Extra) => {
  if (e1.type === 'Workday' && e2.type !== 'Workday') return -1;
  if (e2.type === 'Workday' && e1.type !== 'Workday') return 1;

  return e1.name.localeCompare(e2.name);
};

export const getEmptyServicesByCategoryAndBuildingId = (): ExtraServicesByCategoryByBuildingIdType => ({
  General: {},
  WorkdayBased: {},
  EventBased: {},
  LocationBased: {},
});

export const groupServicesByCategoryAndBuildingId = (
  apiResponse: ExtraServiceDto[],
  allowedBuildings: Dictionary<Building>,
) => {
  const sortedNormalizedServices = flatMap(apiResponse, (service) =>
    service.buildingIds.reduce((acc, curr) => {
      const building = allowedBuildings[curr];
      if (!building) return acc;

      return [
        ...acc,
        {
          ...omit(service, 'buildingIds'),
          buildingId: curr,
          locationTypes: service.category === 'LocationBased' ? service.locationTypes : null!,
        },
      ];
    }, [] as ExtraService[]),
  ).sort((a, b) => a.title.localeCompare(b.title));

  return sortedNormalizedServices.reduce((acc, curr) => {
    const servicesForCategory = acc[curr.category];
    const servicesForBuilding = servicesForCategory[curr.buildingId] ?? {
      buildingId: curr.buildingId,
      buildingName: allowedBuildings[curr.buildingId]!.name,
      data: [],
    };

    return {
      ...acc,
      [curr.category]: {
        ...servicesForCategory,
        [curr.buildingId]: {...servicesForBuilding, data: [...servicesForBuilding.data, curr]},
      },
    };
  }, getEmptyServicesByCategoryAndBuildingId());
};
